import { UserProfileModel } from "src/app/models/userProfileModel";
import { loadProfile } from "./../../../../core/store/profile/profile.actions";
import { Router, ActivatedRoute } from "@angular/router";
import { AlertService } from "./../../../../shared/services/alert.service";
import {
  signOfferLetterDoc,
  signOfferLetterDocSuccess,
} from "./../../../../core/store/offerletter/offerletter.actions";
import { UserModel } from "src/app/models/userModel";
import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { State } from "../../../../core/store";
import { loadOfferLetterDoc } from "src/app/core/store/offerletter/offerletter.actions";
import { Actions, ofType } from "@ngrx/effects";
import * as moment from "moment";
import { SignDocComponentBase } from "../../../abstract/signDocBase.component";
import {
  OnBoardingDocumentUserModel,
  OnBoardingDocumentModel,
} from "src/app/models/onBoardingDocumentUserModel";
import {
  signOnboardingDoc,
  loadOnboardingDoc,
  signOnboardingDocSuccess,
  getOnboardingDocsList,
  loadOnboardingDocInfo,
} from "src/app/core/store/onboardingdocs/onboardingdocs.actions";
import { tap } from "rxjs";
import { downloadFile, deepClone, clearArray } from "src/app/helpers/utils";

@Component({
    selector: "app-sign-onboardingdoc",
    templateUrl: "./sign-onboardingdoc.component.html",
    styleUrls: ["./sign-onboardingdoc.component.scss"],
    standalone: false
})
export class SignOnboardingDocComponent
  extends SignDocComponentBase
  implements OnInit, AfterViewInit
{
  @Input() onboardingDocUserId: string;
  @Input() doNotNavigate: boolean;
  loadingSign = false;
  loadingDoc = true;
  user: UserModel;
  @Input() profile: UserProfileModel;
  docsList: OnBoardingDocumentUserModel[];
  docInfo: OnBoardingDocumentUserModel;

  constructor(
    private store: Store<State>,
    private actions$: Actions,
    private alert: AlertService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    super(store);
  }

  ngOnInit() {
    if (
      this.router.url.indexOf("employee-file/") >= 0 ||
      this.router.url.indexOf("onboarding-manage/") >= 0
    ) {
      this.isSigningAsHRManager = true;
    }
    this.store.dispatch(loadProfile());
    this.store.dispatch(getOnboardingDocsList({ userId: null }));
    if (this.onboardingDocUserId) {
      this.optionalFields.length = 0;
      this.store.dispatch(
        loadOnboardingDoc({
          onboardingDocUserId: parseInt(this.onboardingDocUserId, 10),
        }),
      );
      this.store.dispatch(
        loadOnboardingDocInfo({
          onboardingDocUserId: parseInt(this.onboardingDocUserId, 10),
        }),
      );
    } else {
      this.route.params.subscribe((params) => {
        if (params.onboardingDocUserId) {
          this.onboardingDocUserId = params.onboardingDocUserId;
          this.optionalFields.length = 0;
          this.store.dispatch(
            loadOnboardingDoc({
              onboardingDocUserId: parseInt(this.onboardingDocUserId, 10),
            }),
          );
          this.store.dispatch(
            loadOnboardingDocInfo({
              onboardingDocUserId: parseInt(this.onboardingDocUserId, 10),
            }),
          );
        }
      });
    }

    this.subs.push(
      this.store
        .select((s) => s.profileState.profile)
        .subscribe((p) => {
          if (p) {
            this.user = p.user;
          }
        }),
      this.store
        .select((s) => s.onBoardingDocsState.docInfo)
        .subscribe((docInfo) => {
          if (docInfo) {
            this.docInfo = docInfo;
            // Make Signature#HRUser#2 optional if the user did not filled RehireDate
            if (
              this.docInfo.onBoarding_Document.fileName.indexOf("i9Form") >= 0
            ) {
              if (this.profile && !this.profile.employee.i9RehireDate) {
                if (this.optionalFields.indexOf("Signature#HRUser#2") < 0) {
                  this.optionalFields.push("Signature#HRUser#2");
                }
                if (this.optionalFields.indexOf("#Signature#HRUser#2") < 0) {
                  this.optionalFields.push("#Signature#HRUser#2");
                }
              }
            }
          }
        }),
      this.store
        .select((s) => s.onBoardingDocsState.docArrayBuffer)
        .subscribe((docArrayBuffer) => {
          if (docArrayBuffer) {
            if (this.intervalFormattingSignature) {
              clearInterval(this.intervalFormattingSignature);
            }
            clearArray(this.signedFields);
            this.url =
              URL.createObjectURL(
                new Blob([docArrayBuffer], {
                  type: "application/pdf",
                }),
              ) +
              "&avoidcache=" +
              new Date().getTime();

            this.afterPdfViewerInit();
          }
        }),
      this.store
        .select((s) => s.onBoardingDocsState.loadingDoc)
        .subscribe((loadingDoc) => {
          this.loadingDoc = loadingDoc;
        }),
      this.store
        .select((s) => s.onBoardingDocsState.loadingSign)
        .subscribe((loadingSign) => {
          this.loadingSign = loadingSign;
        }),
      this.store
        .select((s) => s.onBoardingDocsState.docsList)
        .subscribe((docsList) => {
          this.docsList = docsList;
        }),
      this.actions$
        .pipe(
          ofType(signOnboardingDocSuccess),
          tap((action) => {
            if (!this.doNotNavigate) {
              this.alert
                .confirm(
                  "Documentation signed succesfully",
                  "Documentation signed succesfully. Do you want to download the signed file now?",
                )
                .subscribe(
                  (answer) => {
                    if (answer) {
                      downloadFile(action.docSigned, "document.pdf");
                    }

                    this.router.navigate(["../../list"], {
                      relativeTo: this.route,
                    });
                  },
                  (error) => {
                    this.router.navigate([`../../list`], {
                      relativeTo: this.route,
                    });
                  },
                );
            }
          }),
        )
        .subscribe(),
    );
  }

  get loggedUserName() {
    return !this.user ? "" : this.user.firstName + " " + this.user.lastName;
  }

  get loggedUserEmail() {
    return !this.user ? "" : this.user.email;
  }

  sign() {
    if (!this.finishSignDisabled) {
      this.store.dispatch(
        signOnboardingDoc({
          onboardingDocUserId: parseInt(this.onboardingDocUserId, 10),
          signedFields: deepClone(this.signedFields),
        }),
      );
    }
  }
}
